import React from 'react';
import NoDataFound from '../../../shared/NoDataFound';
import Paginator from '../../../shared/Paginator';
import useToast from './utils/useToast';
import { copyToClipboard } from '../../../utils/copyToClipboard';
import TableSkelton from '../../../shared/TableSkelton';
import '../CreativeList.scss';

function getTypeLabel(type) {
  switch (type) {
    case 'image':
      return 'Image (Cube)';
    case 'swiper':
      return 'Swipe Animated';
    case 'multi_creative_swiper':
      return 'Multi Image Swiper';
    case 'upload_file':
      return 'HTML File';
    case 'video':
      return 'Video Ad';
    case 'gif':
      return 'GIF';
    default:
      return type ? type.charAt(0).toUpperCase() + type.slice(1) : 'Unknown';
  }
}

function getDfpUrl(htmlUrl) {
  const campValue = htmlUrl.substring(htmlUrl.lastIndexOf('/') + 1, htmlUrl.lastIndexOf('.html'));
  return `${htmlUrl}?camp=${campValue}`;
}

function CreativesTable({ tableData, tableLoading, totalRows, PAGE_SIZE, currentPage, setCurrentPage, handleEdit, setPreviewDrawer }) {
  const toast = useToast();
  const totalPages = Math.ceil(totalRows / PAGE_SIZE);
  return (
    <div className="creativeListPage">
      <div className="cl-card">
        <header className="cl-header">
          <div className="cl-title-block">
            <h1 className="cl-title">All WebView Creatives</h1>
            <p className="cl-subtitle">Preview, copy and manage your WebView ad creatives</p>
          </div>
        </header>
        <div className="cl-table-wrap max-h-[calc(100vh-300px)] overflow-y-auto">
          <table className="cl-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>HTML URL</th>
                <th>DFP URL</th>
                <th>Created On</th>
                <th>Actions</th>
              </tr>
            </thead>
            {tableLoading ? (
              <TableSkelton colspan={6} rowSpan={10} />
            ) : tableData.length === 0 ? (
              <NoDataFound colspan={6} />
            ) : (
              <tbody>
                {tableData?.map((row) => (
                  <tr key={row.id}>
                    <td className="cl-name" data-label="Name">{row.creative_name}</td>
                    <td data-label="Type">{getTypeLabel(row.type)}</td>
                    <td data-label="HTML URL">
                      <div className="flex items-center gap-2 min-w-0">
                        <span className="truncate">{row.html_url}</span>
                        <sl-tooltip content="Copy HTML URL">
                          <sl-icon-button
                            library="lucide"
                            name="copy"
                            onClick={() => copyToClipboard(row.html_url)}
                          ></sl-icon-button>
                        </sl-tooltip>
                      </div>
                    </td>
                    <td data-label="DFP URL">
                      <div className="flex items-center gap-2 min-w-0">
                        <span className="truncate">{getDfpUrl(row.html_url)}</span>
                        <sl-tooltip content="Copy DFP URL">
                          <sl-icon-button
                            library="lucide"
                            name="copy"
                            onClick={() => copyToClipboard(getDfpUrl(row.html_url))}
                          ></sl-icon-button>
                        </sl-tooltip>
                      </div>
                    </td>
                    <td data-label="Created On">{row.created_on ? new Date(row.created_on * 1000).toLocaleString() : '-'}</td>
                    <td data-label="Actions">
                      <div className="cl-actions">
                        <sl-tooltip content="Preview Creative">
                          <sl-icon-button
                            library="lucide"
                            name="view"
                            onClick={() => setPreviewDrawer({ open: true, row })}
                          ></sl-icon-button>
                        </sl-tooltip>
                        <sl-tooltip content="Edit Creative">
                          <sl-icon-button
                            library="lucide"
                            name="edit"
                            onClick={() => handleEdit(row)}
                          ></sl-icon-button>
                        </sl-tooltip>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>
        {totalPages > 1 && (
          <div className="cl-pagination">
            <Paginator
              pageCount={totalPages}
              handlePageClick={(e) => setCurrentPage(e.selected)}
              forcePage={currentPage}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default CreativesTable;
